import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="border-stone-100 shadow-card">
          <CardContent className="pt-8 pb-8 text-center">
            <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="h-10 w-10 text-amber-600" />
            </div>
            <h1 className="font-heading text-2xl font-semibold text-slate-900 mb-2">
              Payment Cancelled
            </h1>
            <p className="text-slate-600 mb-6">
              Your payment was cancelled. Your booking has not been confirmed. You can try again or browse other tutors.
            </p>
            <div className="flex flex-col gap-3">
              <Button
                onClick={() => navigate('/tutors')}
                className="rounded-full bg-slate-900 hover:bg-slate-800"
                data-testid="browse-tutors-btn"
              >
                Browse Tutors
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/')}
                className="rounded-full"
              >
                Go to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
